import featuredItemsSection from './featuredItemsSection'

export default featuredItemsSection



// WEBPACK FOOTER //
// ./client/pages/home/featuredItemsSection/index.tsx